<template>
    <div class="editor">
        <h5 class="editor__title">Edycja profilu</h5>

        <section class="editor__section editor__section--data">
            <h5 class="editor__section-title">Dane:</h5>

            <div class="editor__section-content">
                <div class="editor__avatar">
                    <ProfileNewAvatar :avatar="selectedAvatar && selectedAvatar.id ?  selectedAvatar : subProfile.avatar" @showAvatarList="showAvatarList"></ProfileNewAvatar>

                    <span class="editor__remove" @click="confirmToggle">Usuń konto</span>
                </div>

                <div class="editor__section-data">
                    <div class="editor__name input-text">
                        <label for="name" class="input-text">
                            <span class="input-text__label">Imię:</span>
                            <input class="input-text__input" maxlength="20" :class="{'input-error': errors.name && value.length < 3 }" type="text" name="name" id="name" v-model="subProfileData.name" @keydown="isLetter">
                            <span class="error" v-if="errors.name && value.length < 3">{{ errors.name }}</span>
                        </label>
                    </div>

                    <ProfileNewAge 
                        class="editor__age" 
                        :ageError="errors.age"
                        :data="subProfile.age" 
                        @setAge="setAge">
                    </ProfileNewAge>
                    
                    <div class="editor__isPin" v-if=" subProfileData.age > 6">
                        <span class="pin__question">{{ pinText }}</span>

                        <div class="pin__radio" v-if="subProfile.has_pin">
                            <div class="profile-new__radio"> 
                                <input type="radio" id="pin-yes" name="pin" value="yes" v-model="isPin"/>
                                <label class="label" for="pin-yes"><span>Tak</span></label>
                            </div>

                            <div class="profile-new__radio"> 
                                <input type="radio" id="pin-no" name="pin" value="no" v-model="isPin" checked="checked"/>
                                <label class="label" for="pin-no"><span>Nie</span></label>
                            </div>
                        </div>

                        <div class="pin__radio" v-else>
                            <div class="profile-new__radio"> 
                                <input type="radio" id="pin-yes" name="pin" value="yes" v-model="isPin" checked="checked"/>
                                <label class="label" for="pin-yes"><span>Tak</span></label>
                            </div>

                            <div class="profile-new__radio"> 
                                <input type="radio" id="pin-no" name="pin" value="no" v-model="isPin" />
                                <label class="label" for="pin-no"><span>Nie</span></label>
                            </div>
                        </div>

                    </div>

                    <!-- <div class="editor__name" v-if="!isPinChange && subProfile.has_pin && subProfileData.age > 6">
                        <label for="pin" class="input-text">
                            <span class="input-text__label">PIN:</span>
                            <input class="input-text__input"  type="text" name="pin" id="pin" value="* * * *" disabled>
                        </label>
                    </div> -->

                    <ModulePinChangeSingle 
                        class="editor__pins" 
                        v-if="isPin === 'yes' || isPinChange"
                        @setPin="setPin"
                        @confirmRemovePin="confirmRemovePin"
                        :subProfileId="subProfile._id"
                        :pinError="errors.pin">
                    </ModulePinChangeSingle>

                    <!-- <InputCheckbox
                        class="editor__sound-prompts"
                        :name="'sound'"
                        :label="'Dźwięk komunikatów głosowych'"
                        :data="subProfile.sound_prompts"
                        @setCheckboxValue="setSoundPrompts">
                    </InputCheckbox> -->

                    <!-- <div class="editor__facilities">
                        <p class="editor__facilities-label">Niektóre nasze programy, posiadają napisy lub są prezentowane w języku migowym. Określ potrzeby dziecka, aby treści z ułatwieniami dostępu wyświetlały się w wyżej w wybranych strefach.</p>
                                    
                        <InputCheckbox
                            :name="'ad'"
                            :label="'Pokaż wyżej treści z audiodeskrypocją'"
                            :data="subProfile.dysfunction.audio_description"
                            @setCheckboxValue="setAudioDescription">
                        </InputCheckbox>

                        <InputCheckbox
                            :name="'sa'"
                            :label="'Włącz automatycznie napisy w treściach wideo'"
                            :data="subProfile.dysfunction.subtitles_auto"
                            @setCheckboxValue="setSubtitlesAuto">
                        </InputCheckbox>

                        <InputCheckbox
                            :name="'sl'"
                            :label="'Wyświetl wyżej treści w językiem migowym'"
                            :data="subProfile.dysfunction.sign_language"
                            @setCheckboxValue="setSignLanguage">
                        </InputCheckbox>
                    </div> -->
                </div>
            </div>
        </section>

        <section class="editor__section editor__section--settings">
            <h5 class="editor__section-title">Ustawienia:</h5>

            <div class="editor__section-wrapper">
                <div class="editor__timelimit">
                    <ProfileNewTimelimit
                        :data="subProfile.game_restriction.time_limit"
                        :error="errors.timeLimit"
                        @selectTimeLimit="selectTimeLimit">
                    </ProfileNewTimelimit>
                </div>

                <div class="editor__sleephours">
                    <ProfileNewSleephours
                        :hours="[subProfile.game_restriction.play_from, subProfile.game_restriction.play_to]"
                        @selectSleepHours="selectSleepHours">
                    </ProfileNewSleephours>
                </div>
            </div>
        </section>

        <div class="editor__btns">
            <button class="editor__btn editor__btn--reject" @click="reject"><span>Anuluj</span></button>
            <button to="/strefa-rodzica" class="editor__btn editor__btn--save"  @click="saveChanges"><span>Zapisz zmiany</span></button>
        </div>

        <ProfileAvatarList v-if="isAvatarList" :activeAvatar="subProfile.avatar._id" @closeModal="closeModal" :isChange="true"></ProfileAvatarList>

        <div class="editor__confirm" v-if="isConfirmModal && !isRemoved">
            <div class="editor__confirm-wrapper">
                <IconClose class="editor__confirm-close close" @click="confirmToggle"></IconClose>

                <h5 class="editor__confirm-title">Czy na pewno chcesz usunąć wybrany profil?</h5>

                <div class="editor__confirm-btns">
                    <button class="editor__confirm-btn editor__confirm-btn--reject" @click="confirmToggle">Anuluj</button>
                    <button class="editor__confirm-btn editor__confirm-btn--confirm" @click="removeSubprofile">Tak</button>
                </div>
            </div>
        </div>

        <div class="editor__confirm" v-if="isConfirmRemovePin">
            <div class="editor__confirm-wrapper">
                <IconClose class="editor__confirm-close close" @click="confirmRemoveToggle"></IconClose>

                <h5 class="editor__confirm-title">Czy na pewno chcesz usunąć PIN?</h5>

                <div class="editor__confirm-btns">
                    <button class="editor__confirm-btn editor__confirm-btn--reject" @click="confirmRemoveToggle">Anuluj</button>
                    <button class="editor__confirm-btn editor__confirm-btn--confirm" @click="removePin">Tak</button>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import globalDataLayer from '../../mixins/globalDataLayer'
import ProfileNewAvatar from "../profile/ProfileNewAvatar.vue";
import ProfileNewAge from "../profile/ProfileNewAge";
// import InputCheckbox from "../profile/InputCheckbox";
import ProfileNewTimelimit from "../profile/ProfileNewTimelimit";
import ProfileNewSleephours from "../profile/ProfileNewSleephours";
import ProfileAvatarList from "../profile/ProfileAvatarList.vue";
import IconClose from "../elements/icons/IconClose.vue";
import ModulePinChangeSingle from "../modules/ModulePinChangeSingle";

const toast = useToast()

export default {
    name: "ProfileSingleEdit",
    components: {
        ProfileNewAvatar,
        // InputCheckbox,
        ProfileNewAge,
        ProfileNewSleephours,
        ProfileNewTimelimit,
        ProfileAvatarList,
        IconClose,
        ModulePinChangeSingle
    },
    mixins: [globalDataLayer],
    props: {
        subProfile: {
            type: Object
        }
    },    
    data() {
        return {
            UPDATE_SUBPROFILE: '/api/krainaabc/subprofile/update?device=www',
            DELETE_SUBPROFILE: '/api/krainaabc/subprofile/delete?device=www',
            REMOVE_PIN: 'api/krainaabc/subprofile/pin-remove?device=www',
            subProfileData: {},
            isPin: 'no',
            isPinChange: false,
            errors: {
                name: '',
                age: '',
                pin: '',
                timeLimit: ''
            },
            newPin: '',
            // newPinRepeat: '',
            showPin: false,
            showPinRepeat: false,
            newPinError: '',
            // newPinRepeatError: '',
            pinError: '',
            isConfirmModal: false,
            isRemoved: false,
            isAvatarList: false,        
            isConfirmRemovePin: false, 
        };
    },
    computed: {
        selectedAvatar() {
            return this.$store.getters.getSelectedAvatar;
        },
        accountFunction() {
            if(this.subProfile){
                return this.subProfile.dysfunction.audio_description + this.subProfile.dysfunction.subtitles_auto + this.subProfile.dysfunction.sign_language
            }
            return null;
        },
        pinText() {
            if(this.subProfile && this.subProfile.has_pin) {
                return 'Czy chcesz zmienić PIN dziecku?';
            } else {
                return 'Czy chcesz ustawić PIN dla dziecka?'
            }
        }
    },
    watch: {
        selectedAvatar(avatar) {
            if(avatar) {
                this.subProfileData.avatar = avatar.id;
            }
        }
    },
    methods: {
        initSubProfileData() {
            if(this.subProfile) {
                this.subProfileData.id = this.subProfile._id;
                this.subProfileData.name = this.subProfile.name;
                this.subProfileData.age = this.subProfile.age;
                this.subProfileData.pin = this.subProfile.pin;
                this.subProfileData.avatar = this.subProfile.avatar._id;
                this.subProfileData.sound_prompts = false;
                // this.subProfileData.audio_description = this.subProfile.dysfunction.audio_description;
                // this.subProfileData.subtitles_auto = this.subProfile.dysfunction.subtitles_auto;
                // this.subProfileData.sign_language = this.subProfile.dysfunction.sign_language;
                this.subProfileData.time_limit = this.subProfile.game_restriction.time_limit;
                this.subProfileData.play_from = this.subProfile.game_restriction.play_from;
                this.subProfileData.play_to = this.subProfile.game_restriction.play_to;
                this.subProfileData.set_pin = this.subProfile.isPin === 'yes' ? true : false;
            }
        },
        reject() {
            this.$store.dispatch("changeSelectedAvatar", null); // resetowanie wybranego awtara
            this.$emit("editToggle");
        },
        saveChanges() {
            if(this.validation()) {
                axios
                    .post(this.UPDATE_SUBPROFILE, this.subProfileData)
                    .then((response) => { 
                        if(response.status === 200 && response.data) {
                            if(response.data.error) {
                                toast.error("Nie udało się wprowadzić zmian"); 
                            } else {
                                this.$emit("editToggle");
                                this.$store.dispatch("subProfiles");
                                this.$store.dispatch("changeSelectedAvatar", null);

                                toast.success("Zapisano zmiany");

                                this.$router.push({
                                    name: "Account",
                                    path: "/strefa-rodzica",
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        toast.error("Nie udało się wprowadzić zmian");                         
                        console.log(error);
                    });
            }
        },
        validation() {
            let validate = true;

            if(this.subProfileData.name.length < 3) {
                this.errors.name = 'Podaj imię dziecka';
                validate = false;
            } else {
                this.errors.name = '';
            }


            if(this.subProfileData.name.length < 3 ) {
                if(this.subProfileData.name.length > 0 ) {
                    this.errors.name = 'Imię jest zbyt krótkie';
                    toast.error("Imię jest zbyt krótkie"); 
                    validate = false;
                } else {
                    this.errors.name = 'Podaj imię dziecka';
                    toast.error("Podaj imię dziecka"); 
                    validate = false;
                }
            } else if (!/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]+$/.test(this.subProfileData.name)) {
                this.errors.name = 'Imię może zawierać tylko litery';
                toast.error("Imię może zawierać tylko litery"); 
                validate = false;
            } else {
                this.errors.name = '';
            }

            if(this.subProfileData.age < 3) {
                this.errors.age = 'Podaj wiek dziecka';
                validate = false;
            } else {
                this.errors.age = '';
            }

            if(this.isPin === 'yes') {
                if(!this.subProfileData.pin || this.subProfileData.pin.length !== 4) {
                    this.errors.pin = 'PIN musi się składać z 4 cyfr';
                    toast.error("PIN musi się składać z 4 cyfr"); 
                    validate = false;
                } else {
                    this.errors.pin = '';
                }
                this.subProfileData.set_pin = true;
            } else {
                this.errors.pin = '';
                this.subProfileData.set_pin = false;
            }

            if(this.subProfileData.timeLimit === -1) {
                this.errors.timeLimit = 'Ustaw limit czasu';
                validate = false;
            } else {
                this.errors.timeLimit = '';
            }

            if(validate === false) {
                this.scrollToError();
            }

            return validate;
        },
        setAge(value) {
            this.subProfileData.age = value;
            this.errors.age = '';

            if(value < 7) {
                this.isPin = 'no';
            }
        },
        setPin(value) {
            this.subProfileData.pin = value;
            this.errors.pin = '';
        },
        // setSoundPrompts(value) {
        //     this.subProfileData.sound_prompts = value;
        // },
        selectTimeLimit(value) {
            this.subProfileData.time_limit = parseInt(value);
            this.errors.timeLimit = '';
        },
        selectSleepHours(value) {
            this.subProfileData.play_from = this.getHour(value[0]);
            this.subProfileData.play_to = this.getHour(value[1]);
        },
        // setAudioDescription(value) {
        //     this.subProfileData.audio_description = value;
        // },
        // setSubtitlesAuto(value) {
        //     this.subProfileData.subtitles_auto = value;
        // },
        // setSignLanguage(value) {
        //     this.subProfileData.sign_language = value;
        // },   
        scrollToError() {
            setTimeout(function() {
                const firstErr = document.querySelector(
                    '.error'
                );

                if (firstErr) {
                    const elToScroll = firstErr.parentElement;
                    const startPos = window.pageYOffset;
                    const diff = elToScroll.getBoundingClientRect().top;

                    window.scrollTo({
                        top: startPos + diff - 100,
                        behavior: 'smooth'
                    });
                 }
            }, 200);
        },   
        showAvatarList() {
            this.isAvatarList = true;
            this.$store.dispatch("changeModalBackdrop", true);  
        },
        closeModal() {
            this.isAvatarList = false;
            this.$store.dispatch("changeModalBackdrop", false);
        },
        confirmToggle() {
            this.isConfirmModal = !this.isConfirmModal;
            if(this.isConfirmModal) {
                this.$store.dispatch("changeModalBackdrop", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
            }

            this.$store.dispatch("subProfiles");
        },
        confirmRemoveToggle() {
            this.isConfirmRemovePin = !this.isConfirmRemovePin;
            if(this.isConfirmRemovePin) {
                this.$store.dispatch("changeModalBackdrop", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        removeSubprofile() {
            let data = {};
            data['id'] = this.subProfile._id;
            axios
                .post(this.DELETE_SUBPROFILE, data)
                .then(() => { 
                    this.isRemoved = true;
                    toast.success("Usunięto profil");
                })
                .catch(() => {
                    toast.error("Nie udało się usunąć profilu");
                })
                .finally(()=> {
                    this.$emit("editToggle");
                    this.$store.dispatch("subProfiles");
                    this.$store.dispatch("changeModalBackdrop", false);
                    this.$router.push({
                        name: "Account",
                        path: "/strefa-rodzica",
                    });  
                });
        },
        closeModule() {
            this.isPinChange = false;
            this.isPin = 'no';
            this.$store.dispatch("subProfiles");
        },
        getHour(time) {
            if(time === 24) {
                return '23:59';
            }
            else if(time.toString().length < 2) {
                return `0${Math.floor(time)}:00`;
            } else {             
                return `${Math.floor(time)}:00`;
            }
        },        
        isLetter(e) {
            if ((!/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]/.test(e.key) && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        },
        confirmRemovePin() {
            this.isConfirmRemovePin = true;
            this.$store.dispatch("changeModalBackdrop", true);
        },
        removePin() {
            const data = {};

            if(this.subProfileData.id !== '') { 
                data['subProfile_id'] = this.subProfileData.id;
            } else { 
                data['src'] = 'krainaabc';
            }

            axios
                .post(this.REMOVE_PIN, data)
                .then((response) => {
                    if(response && response.data && response.data.error) {
                        toast.error("Nie udało sie usunąć PINu");
                    } else {
                        toast.success("PIN został usunięty");
                        this.isConfirmRemovePin = false;
                        this.$store.dispatch("subProfiles");
                        this.$store.dispatch("changeModalBackdrop", false);
                        this.isPin = 'no';
                    }
                })
                .catch(() => {
                    toast.error("Nie udało sie usunąć PINu");
                })
        }
    },
    mounted() {
        this.initSubProfileData();
    }
};
</script>